import createArticleApi from '~/api/article';
import createHomeApi from '~/api/home';
import createArticlesApi from '~/api/articles';
import createTermsApi from '~/api/terms';
import createDeliveryApi from '~/api/delivery';
import createSearchApi from '~/api/search';
import createPageBuilderApi from '~/api/page-builder';
import createContactsApi from '~/api/contacts';
import createProductsApi from '~/api/products';
import createProductApi from '~/api/product';
import createCategoryApi from '~/api/category';
import createLocationsApi from '~/api/locations';
import createOrderApi from '~/api/order';
import createAdvantagesApi from '~/api/advantages';
import createAboutApi from '~/api/about';
import createReviewsApi from '~/api/reviews';
import createVacanciesApi from '~/api/vacancies';
import createUserApi from '~/api/user';
import createGalleryApi from '~/api/gallery';
import createPartnersApi from '~/api/partners';
import createIntegrationsApi from '~/api/integrations';
import createBrandsApi from '~/api/brands';
import createCreditCalculatorApi from '~/api/credit-calculator';

export default ({ $axios }, inject) => {
    const api = {
        article: createArticleApi($axios),
        home: createHomeApi($axios),
        terms: createTermsApi($axios),
        delivery: createDeliveryApi($axios),
        search: createSearchApi($axios),
        contacts: createContactsApi($axios),
        pageBuilder: createPageBuilderApi($axios),
        articles: createArticlesApi($axios),
        products: createProductsApi($axios),
        category: createCategoryApi($axios),
        product: createProductApi($axios),
        locations: createLocationsApi($axios),
        order: createOrderApi($axios),
        advantages: createAdvantagesApi($axios),
        about: createAboutApi($axios),
        reviews: createReviewsApi($axios),
        vacancies: createVacanciesApi($axios),
        user: createUserApi($axios),
        gallery: createGalleryApi($axios),
        partners: createPartnersApi($axios),
        integrations: createIntegrationsApi($axios),
        brands: createBrandsApi($axios),
        creditCalculator: createCreditCalculatorApi($axios)
    };

    // Inject the api to the context as $api
    inject('api', api);
};
